import Vue from 'vue';
import Vuex from 'vuex';

import home from './modules/home';
import auth from './modules/auth';
import profile from './modules/profile';
import user from './modules/user';
import client from './modules/client';
import digitalizations from './modules/digitalizations';
import disposals from './modules/disposals';
import file from './modules/file';
import box from './modules/box';
import location from './modules/location';
import locationNode from './modules/locationNode';
import imports from './modules/imports';
import order from './modules/order';
import orderGeneral from './modules/orderGeneral';
import pickup from './modules/pickup';
import tariff from './modules/tariff';
import services from './modules/services';
import materiales from './modules/materiales';
import firstPickup from './modules/firstPickup';
import rangeBoxGeneral from './modules/rangeBoxGeneral';
import liquidation from './modules/liquidation';
import inquiries from './modules/inquiries';
import itemIncome from './modules/itemIncome';
import storageLocation from './modules/storageLocation';
import trackingGeneral from './modules/trackingGeneral';
import low from './modules/low';

import {resetState} from './reset';

Vue.use(Vuex);

const store = new Vuex.Store({

  state: {},

  mutations: {
    RESET_ALL(state) {
      resetState(state);
    }
  },

  modules: {
    home,
    auth,
    profile,
    user,
    client,
    digitalizations,
    disposals,
    file,
    box,
    location,
    locationNode,
    imports,
    order,
    orderGeneral,
    pickup,
    tariff,
    services,
    materiales,
    firstPickup,
    rangeBoxGeneral,
    liquidation,
    inquiries,
    itemIncome,
    storageLocation,
    trackingGeneral,
    low
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js